import { DataTable, FormLabel, Heading, Loader, Select } from "@/components";
import { Card, CardContent, Tabs, TabsList, TabsTrigger } from "@/components/ui";
import { cn } from "@/lib/utils";
import { SHARED_ME, tabs } from "./consts";
import useMyNeighbors from "./useMyNeighbors";
import { Info } from "lucide-react";

const MyNeighbors = () => {
  const { activeTab, onTabChange, isMobile, isLoadingNeighborList, onChangeProperty,
    neighborList, columns, propertyId, myProperties, isLoadingProperties } = useMyNeighbors();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <Heading title={"My Neighbors"} />
        <div className="relative w-[350px]">
          <FormLabel>Select Property</FormLabel>
          <Select 
            placeholder=""
            searchPlaceholder="Search...."
            noDataPlaceholder="No Data Found"
            options={myProperties?.map((data: any) => ({
              label: `${data?.propertyName || ""} | ${data?.blockName || ""} | ${data?.zoneName || ""} | Unit ${data?.unitNumber || ""}`,
              value: data?.propertyId?.toString()
            }))}
            value={propertyId?.toString()}
            onChange={onChangeProperty}
            disabled={isLoadingProperties}
          />
        </div>
      </div>

      <Card>
        <CardContent>
          <Tabs
            value={activeTab}
            onValueChange={onTabChange}
            className="w-full"
          >
            <TabsList
              className={cn(
                "gap-x-4 bg-white",
                isMobile ? "!w-full !overflow-x-scroll" : ""
              )}
            >
              {tabs.map((tab) => (
                <TabsTrigger
                  key={tab.value}
                  value={tab.value}
                  className="data-[state=active]:shadow-none hover:cursor-pointer text-gray-400 hover:text-primary px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary"
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>

            {activeTab == SHARED_ME ?
              <div className="flex flex-row gap-3 bg-blue-50 p-2 rounded-md border border-blue-300">
                <Info className="stroke-primary h-6 w-6"/>
                <span className="font-normal text-[12px]">
                  These owners have shared their primary contact information with your property. <br/> Your information is not automatically shared with them.
                </span>
              </div> : <></>
            }
            {isLoadingNeighborList ? <Loader /> :
              <DataTable data={neighborList} columns={columns} className="shadow-none border-0" />}
          </Tabs>
        </CardContent>
      </Card>
    </div>
  )
}

export default MyNeighbors;